module.exports = __webpack_public_path__ + "media/components/blocks/ExploreAndDiscover/arrow_down-7ff75a8cfcb75a2ed813d399bbef379a.png";